import { render, staticRenderFns } from "./InformationDialog.vue?vue&type=template&id=363973d2&"
import script from "./InformationDialog.vue?vue&type=script&lang=ts&"
export * from "./InformationDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports